import type { TranslationTree } from '../../types';

export const toolPickers: TranslationTree = {
  toolPickers: {
    reference: {
      placeholder: 'Referenz suchen oder eingeben',
      listTitle: 'Vorhandene Referenzen · {{count}}',
      empty: 'Keine Referenz',
      toolCount: { one: '{{count}} Werkzeug', other: '{{count}} Werkzeuge' },
      current: 'aktuell',
      create: 'Neue Referenz „{{reference}}“ anlegen',
      hint: 'Wählen Sie eine vorhandene Referenz. Ein Wert, der nicht in der Liste steht, legt eine neue Referenz an.',
      currentHint: 'Aktuelle Referenz des Werkzeugs.',
      existing: 'Vorhandene Referenz · {{tools}}',
      existingAlias: 'Vorhandene Referenz · {{tools}} · Alias „{{alias}}“',
      nearTitle: 'Ähnliche Referenz:',
      near: '{{reference}} existiert bereits ({{tools}}). So eingegeben legt „{{value}}“ eine neue Referenz an.',
      use: '{{reference}} verwenden',
      newTitle: 'Neue Referenz.',
      new: '„{{value}}“ existiert noch nicht: Sie wird mit diesem Werkzeug angelegt.',
    },
    toolId: {
      listTitle: 'Werkzeuge des Unternehmens · {{count}}',
      empty: 'Kein passendes Werkzeug',
      more: 'und {{count}} weitere: Suche verfeinern',
      noReference: 'ohne Referenz',
      traces: {
        none: 'keine Erfassung',
        one: '{{count}} Erfassung',
        other: '{{count}} Erfassungen',
      },
      lastTrace: 'zuletzt am {{date}}',
      known: 'Referenz {{reference}} · {{traces}}',
      knownNoReference: 'Ohne Referenz · {{traces}}',
      near: 'Kein Werkzeug „{{value}}“. Meinten Sie {{toolId}}?',
      use: 'Verwenden',
      unknown: 'Kein Werkzeug „{{value}}“ in Ihrem Unternehmen.',
      create: 'Dieses Werkzeug anlegen',
    },
    existingIds: {
      hint: 'Bereits erfasste IDs erscheinen während der Eingabe.',
      takenTitle: 'Dieses Werkzeug existiert bereits',
      taken: '(Referenz {{reference}}, {{traces}}). Eine ID kann nur einmal erfasst werden.',
      openTool: 'Seite von {{toolId}} öffnen und Referenz ändern →',
      near: '{{toolId}} existiert bereits: Nur Gross-/Kleinschreibung oder Trennzeichen unterscheiden sich. Prüfen Sie die Markierung des Werkzeugs.',
      listTitle: 'Bereits erfasste IDs · {{count}}',
      more: 'und {{count}} weitere',
      nextFree: 'Nächste freie Nummer:',
      use: 'Verwenden',
      takenShort: '{{toolId}} existiert bereits: Ändern Sie die Referenz auf der Werkzeugseite.',
      takenElsewhere: 'Diese ID ist bereits von einem anderen Unternehmen erfasst.',
    },
    edit: {
      button: 'Ändern',
      buttonLabel: 'Referenz ändern',
      label: 'Neue Referenz von {{toolId}}',
      note: 'Die Erfassungen des Werkzeugs ändern sich nicht. Nur seine Einordnung ändert sich.',
      move: 'Die Erfassungen des Werkzeugs ändern sich nicht. In der Werkzeugliste wechselt es von {{from}} ({{left}} bleiben) zu {{to}}.',
      moveLast:
        'Die Erfassungen des Werkzeugs ändern sich nicht. In der Werkzeugliste wechselt es von {{from}}, das dann kein Werkzeug mehr hat, zu {{to}}.',
      newReference: '{{reference}} (neu)',
      save: 'Speichern',
      cancel: 'Abbrechen',
      saved: 'Referenz geändert: {{from}} → {{to}}.',
      savedNew: 'Referenz geändert: {{from}} → {{to}} (neue Referenz angelegt).',
      error: 'Die Referenz konnte nicht geändert werden.',
    },
  },
};
